import { Typography } from '@mui/material'
import React from 'react'
import { fontSizes, fontWeights } from '../../../Common/Typography/TypographyStyles'

interface TaskTitleProps {
  value: string
}

const TaskTitle: React.FC<TaskTitleProps> = ({ value }) => {
  return (
    <Typography
      sx={{
        maxWidth: '100%',
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
        wordBreak: 'break-word',
        textAlign: 'left',
        display: '-webkit-box',
        WebkitLineClamp: 3,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        margin: 0,
        fontSize: fontSizes.size12,
        fontWeight: fontWeights[700],
        flex: 1,
        lineHeight: 1.4,
        maxHeight: '50.4px', // 3 lines * 16.8px line height (12px * 1.4)
      }}
    >
      {value}
    </Typography>
  )
}

export default TaskTitle
